import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownPanelProps {
  headline: string;
  subtext: string;
}
export function CountdownPanel({
  headline,
  subtext
}: CountdownPanelProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'h'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  return <div className="mx-auto w-full max-w-narrow rounded-2xl bg-amber-100 px-6 py-8 text-center ring-1 ring-amber-200 md:px-10" data-id="element-33" data-mp="l8rz1gkwyjv2">
      <p className="inline-flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.14em] text-night md:text-base" data-id="element-34" data-mp="c68xr0ws0fax">
        <AlertTriangleIcon className="h-5 w-5 shrink-0 text-amber-700" aria-hidden="true" data-id="element-35" data-mp="h5val98oztj7" />
        {headline}
      </p>

      <div className="mt-6 flex items-start justify-center gap-5 md:gap-9" role="timer" data-id="element-36" data-mp="26kryoz1o6aqu">
        {units.map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-37" data-mp="2bgqsj25rokyn">
            <span className="font-display text-5xl font-extrabold tabular-nums leading-none tracking-tight text-night md:text-6xl" data-id="element-38" data-mp="1lfdqsln6k1ld">
              {unit.value}
            </span>
            <span className="mt-2 text-xs font-bold uppercase tracking-[0.2em] text-gray-600" data-id="element-39" data-mp="1v5ouc72yc8rq">
              {unit.label}
            </span>
          </div>)}
      </div>

      <p className="mt-6 font-semibold text-gray-700" data-id="element-40" data-mp="12hkmbewwrjlv">{subtext}</p>
    </div>;
}